import Vue from 'vue';
import authService from '../services/auth.service';
import langService from '../services/lang.service';
import personalizationService from '../services/personalization.service';

const actions = {
    setCulture: ({ commit, store }, payload) => {
        if (payload.lang) {
            commit('setCulture', { language: payload.lang });
            payload.service.locale = payload.lang;
            localStorage.setItem('culture', payload.lang);
        }
    },
    loadLanguageAsync: ({ commit, getters }, lang) => {
        return new Promise((resolve, reject) => {
            if (lang && !getters.loadedLanguages.includes(lang)) {
                langService.get(lang)
                .then(response => {
                    commit('setLocale', { lang: lang });

                    if (response.status === 202) {
                        console.log(response.data)
                    } else {
                        if (response.data) {
                            resolve({ lang: lang, locale: response.data });
                        }
                    }
                })
                .catch(error => {
                    reject(error)
                });
            }
        })
    },
    loadUserSettingsAsync: ({ commit, getters }) => {
        return new Promise((resolve, reject) => {
            if (getters.isAuthenticated) {
                personalizationService
                    .loadUserSettings(getters.userId).then(response => {
                   if (response.data) {
                       commit('setUserSettings', { userSettings: response.data });
                   }
                   resolve({ userSettings: response.data || {} });
                })
                .catch(error => {
                   reject(error)
                });
            }
        })
    },
    loadAppSigningSettingsAsync: ({ commit, getters }) => {
        return new Promise((resolve, reject) => {
            if (getters.isAuthenticated) {
                console.log('User is authenticated. Loading AppSigningSettings.')
                personalizationService
                    .loadAppSigningSettings().then(response => {
                        if (response.data) {
                            commit('setAppSigningSettings', { appSigningSettings: response.data });
                        }
                        resolve({ userSettings: response.data || {} });
                    })
                    .catch(error => {
                        reject(error)
                    });
            }
        })
    },
    loadCurrentUserClaims: ({ commit, getters }) => {
        return new Promise((resolve, reject) => {
            if (getters.isAuthenticated) {
                authService.currentUserClaims()
                    .then(userClaims => {
                        commit('updateClaims', userClaims);
                        resolve(true);
                    })
                    .catch(error => {
                        reject(error)
                    });
            }
        })
    },
    setActiveRoute: ({ commit }, route) => {
        commit('setActiveRoute', { route });
    },
    toggleSideMenu: ({ commit }) => {
        commit('toggleSideMenu');
    },
    setSideMenuVisibility: ({ commit }, val) => {
        commit('setSideMenuVisibility', { val });
    },
    setUserData({ commit }, userData) {
        if (userData) {
            commit('authenticateUser', userData);
        }
    },
    setUserTasks({ commit }, val) {
        commit('setUserTasks', val);
    },
    setEventReadRights({ commit }, val) {
        commit('setEventReadRights', val);
    },
    setEventEditRights({ commit }, val) {
        commit('setEventEditRights', val);
    },
    setEventClaims({ commit }, val) {
        commit('setEventClaims', val);
    },
    setUserClaims({ commit }, val) {
        commit('setUserClaims', val);
    },
    login({ dispatch, commit }, loginData) {
        authService.login(loginData)
            .then(data => {
                if (data) {
                    commit('authenticateUser', data);
                }

                try {
                    Vue.prototype.startEventsSignalR(data.token);
                } catch (e) {
                    console.log(e)
                }

                try {
                    Vue.prototype.startTasksSignalR(data.token);
                } catch (e) {
                    console.log(e)
                }
            })
            .catch(error => {

            });
    },
    register({ commit }, registerData) {
        authService.register(registerData)
            .then(data => {
                if (data) {
                    commit('authenticateUser', data);
                }
            })
            .catch(error => {

            });
    },
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            authService.logout()
                .then(data => {
                    commit('logout');
                    localStorage.setItem('user', '');

                    try {
                        Vue.prototype.stopEventsSignalR()
                    } catch (e) {

                    }

                    try {
                        Vue.prototype.stopTasksSignalR()
                    } catch (e) {

                    }

                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    setPageTitle({ commit }, val) {
        commit('setPageTitle', val);
    },
    restoreContext({ commit, getters }) {
        commit('restoreContext');

        if (getters.isAuthenticated) {
            try {
                Vue.prototype.startEventsSignalR(getters.authToken);
            } catch (e) {
                console.log(e)
            }

            try {
                Vue.prototype.startTasksSignalR(getters.authToken);
            } catch (e) {
                console.log(e)
            }
        }
    },
    destroyHubs({ commit, getters }) {
        try {
            Vue.prototype.stopEventsSignalR()
        } catch (e) {

        }

        try {
            Vue.prototype.stopTasksSignalR()
        } catch (e) {

        }
    },
    setCurrentRegisterData({ commit }, register) {
        commit('setCurrentRegisterData', register);
    },
    clearCurrentRegisterData({ commit }, register) {
        commit('clearCurrentRegisterData', register);
    },
    setReportingServerUrl({ commit }, url) {
        commit('setReportingServerUrl', url);
    },
    loadUserPolicies: async ({ commit, getters }) => {
        commit('loadUserPolicies');
    },
    clearUserPolicies: ({ commit }) => {
        commit('clearUserPolicies');
    },
}

export default actions;
